import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { trackEvent } from 'analytics/trackFunctions'
import PageWrapper from './PageWrapper'

import PrimaryButton from './primaryButton'

import subscriptionSuccessImg from '../assets/images/subscriptionSuccess.png'
import subscriptionErrorImg from '../assets/images/subscriptionError.png'

const subscrResult = {
  sucess: 'exitosa',
  error: 'erronea'
}
const title = {
  succes: 'Suscripción exitosa',
  error: 'Suscripción errónea'
}

const SubscriptionResult = () => {
  const { id } = useParams()

  useEffect(() => {
    if (id === subscrResult.error) {
      trackEvent({
        eventName: 'bille_wayniplus_suscribirme_error'
      })
    } else {
      trackEvent({ eventName: 'bille_wayniplus_suscribirme_confirmada' })
    }
  }, [])

  return (
    <PageWrapper
      noTabBar
      viewSelected='/home'
      title={id === subscrResult.sucess ? title.succes : title.error}
    >
      {id === subscrResult.sucess && <SubscriptionSuccess />}
      {id === subscrResult.error && <SubscriptionError />}
    </PageWrapper>
  )
}

export default SubscriptionResult

const SubscriptionResultComponent = ({
  image,
  children,
  onClick,
  outline = false,
  text = 'Volver al inicio',
  success = true
}) => {
  const navigate = useNavigate()
  return (
    <div className='flex w-full h-[78vh] items-center justify-between sm:justify-around flex-col'>
      <div className='flex flex-col items-center'>
        <img src={image} alt='' />
        <div className='font-manrope font-bold font-base text-xl leading-5 text-gray-900 text-center mt-5 px-3 md:px-20'>
          {children}
        </div>
      </div>

      <div className='w-full md:max-w-sm'>
        {success && (
          <PrimaryButton
            primaryButtonFunction={onClick}
            className='px-3'
            buttonText='Ver mis beneficios'
            type='button'
          />
        )}
        <PrimaryButton
          primaryButtonFunction={() => {
            navigate('/home')
            trackEvent({
              eventName: 'bille_wayniplus_suscribirme_error_inicio'
            })
          }}
          className='px-3 mt-2'
          buttonText={text}
          outlined={outline}
          type='button'
        />
      </div>
    </div>
  )
}
const SubscriptionSuccess = () => {
  const navigate = useNavigate()

  return (
    <SubscriptionResultComponent
      image={subscriptionSuccessImg}
      outline
      success
      onClick={() => {
        navigate('/suscripcion')
        trackEvent({
          eventName: 'bille_wayniplus_suscribirme_confirmada_beneficios'
        })
      }}
      data-testid='resultSuccess'
    >
      <div className='my-8'>
        <p className='text-black text-2xl  font-bold leading-6 max-w-[250px] mx-auto'>
          ¡Tu membresía fue activada con éxito!
        </p>
        <p className='text-black font-manrope text-xl font-normal leading-6 mt-2'>
          Te contamos todos los beneficios que tenes con{' '}
          <span className='font-bold text-xl leading-6  '>Wayni</span>
          <span className='text-[#0FD08B] text-xl font-bold'>+</span>
        </p>
      </div>
    </SubscriptionResultComponent>
  )
}

const SubscriptionError = () => (
  <SubscriptionResultComponent image={subscriptionErrorImg} success={false}>
    <div className='my-8'>
      <p className='text-black text-2xl  font-bold leading-6 max-w-[250px] mx-auto'>
        ¡Ha ocurrido un error con tu subscripción!
      </p>
      <p className='text-black font-manrope text-xl font-normal leading-6 mt-2'>
        Podés volver a intentarlo más tarde
      </p>
    </div>
  </SubscriptionResultComponent>
)
